import {memo} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'

import {BASE_CLASS} from './config.js'

const CardCertificationIconListItem = ({iconUrl, title}) => (
  <li className={`${BASE_CLASS}-listIconItemWrapper`}>
    <div className={`${BASE_CLASS}-listIconImageWrapper`}>
      <AtomImage alt={title} className={`${BASE_CLASS}-listIconImage`} src={iconUrl} />
    </div>
    <p className={`${BASE_CLASS}-listItemValue`}>{title}</p>
  </li>
)

CardCertificationIconListItem.displayName = 'CardCertificationIconListItem'
CardCertificationIconListItem.propTypes = {
  iconUrl: PropTypes.string,
  title: PropTypes.string
}

export default memo(CardCertificationIconListItem)
